export default __webpack_public_path__ + "static/shappi-khorsandi-81f22a8e1b38e2c4ce0200ebbc1a9b0b.png";